var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-btn",
    {
      staticClass: "font-weight-bold white--text primary",
      attrs: {
        "v-bind": _vm.$props,
        disabled: _vm.disabled,
        depressed: "",
        "x-large": _vm.xLarge
      },
      on: {
        click: function($event) {
          return _vm.$emit("click", $event)
        }
      }
    },
    [
      _vm._t("default", function() {
        return [_vm._v("App Button")]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }